import gsap from "gsap";
import { useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getComputed, useThemeChange } from "./Theme";

function HelloMessage() {
  const [textColor, setTextColor] = useState(
    getComputed(document.documentElement, "--color-text"),
  );
  const [themeChanges, setThemeChanges] = useState(0);
  const accentColors = [
    "--color-accent-pink",
    "--color-accent-cyan",
    "--color-accent-yellow",
    "--color-accent-orange",
    "--color-accent-green",
    "--color-accent-blue",
    "--color-accent-purple",
  ];
  const [nameColor, setNameColor] = useState(
    `var(${accentColors[Math.floor(Math.random() * accentColors.length)]})`,
  );
  useThemeChange(() => {
    setTextColor(getComputed(document.documentElement, "--color-text"));
    setNameColor(
      `var(${accentColors[Math.floor(Math.random() * accentColors.length)]})`,
    );
    setThemeChanges((v) => v + 1); // force re-render and skip animation
  });
  const { t } = useTranslation();
  const hasRendered = useRef(false);
  const tlRef = useRef<gsap.core.Timeline | null>(null);

  const letterMap = (message: string, className: string, isName = false) => {
    let color = undefined;
    if (hasRendered.current) {
      color = isName ? nameColor : textColor;
    }
    return message.split("").map((char, index) => (
      <span
        key={index}
        className={className}
        style={{
          opacity: 0,
          color: color,
        }}
      >
        {char}
      </span>
    ));
  };

  const helloMessageLetters = () => {
    const {
      before = "",
      name = "",
      after = "",
    } = t("hello_message", { returnObjects: true }) || {};
    return (
      <>
        {letterMap(before, "hello-letter")}
        <span className="name-letter">
          {letterMap(name, "hello-letter name-letter", true)}
        </span>
        {letterMap(after, "hello-letter")}
      </>
    );
  };

  useLayoutEffect(() => {
    const helloLetters = gsap.utils.toArray<Element>(".hello-letter");
    hasRendered.current = true;

    if (tlRef.current) {
      tlRef.current.kill();
      const helloLetters = gsap.utils.toArray<Element>(".hello-letter");
      gsap.set(helloLetters, { opacity: 1, color: textColor });
      gsap.set(".name-letter", { opacity: 1, color: nameColor });
      return;
    }

    const tl = gsap.timeline({ repeat: 0 });
    tlRef.current = tl;

    helloLetters.forEach((letter, index) => {
      const isName = letter.classList.contains("name-letter");
      const shuffledColors = gsap.utils.shuffle([...accentColors]);
      tl.to(
        letter,
        {
          keyframes: [
            ...shuffledColors.map((color) => ({ color: `var(${color})` })),
            { color: isName ? nameColor : textColor },
          ],
          opacity: 1,
          duration: 0.7,
          ease: "none",
        },
        index * 0.1,
      );
    });
  }, [t, themeChanges]);

  return helloMessageLetters();
}

export default HelloMessage;
